
// @mui material components
import { useContext, useEffect } from "react";
import { AuthContext } from "context";

import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import BookingCard from "examples/Cards/BookingCard";

// Anaytics dashboard components
import SalesByCountry from "layouts/dashboards/analytics/components/SalesByCountry";

// Data
import reportsBarChartData from "layouts/dashboards/analytics/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboards/analytics/data/reportsLineChartData";

function RoadDashboard() {
    const { sales, tasks } = reportsLineChartData;

    const { user, setIsAuthenticated } = useContext(AuthContext);

    useEffect(() => {
        if (!user?.id) {
            setIsAuthenticated(false);
            localStorage.removeItem("token");
        }
    }, [user]);

    return (
        <DashboardLayout sx={{ padding: 0, margin: 0 }}>
            <DashboardNavbar />
            <MDBox py={3} sx={{ padding: 0, margin: 0 }}>
                <Grid container spacing={0} sx={{ margin: 0, padding: 0 }}>
                    {/* Sales Component */}
                    <Grid item xs={12}>
                        <MDBox sx={{ margin: 0, padding: 0 }}>
                            <SalesByCountry />
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
            <br />
            <Footer />
        </DashboardLayout>
    );

}

export default RoadDashboard;
